import { inject, Injectable } from '@angular/core';
import { PlayersService } from '../players/players';
import { GameInfoService } from '../games/game-info';
import { RdGameService } from '../games/rd-game';

@Injectable({
  providedIn: 'root'
})
export class EndGameService {

  players = inject(PlayersService);
  gameInfo = inject(GameInfoService);
  rdb = inject(RdGameService);

  isEndOfGame(player_id: number){
    if(this.gameInfo.gameInfo?.stopInACircle){
      const result = this.players.players.find(item => item.player_id === player_id);
      if(!result.hasOwnProperty('own')){
        this.rdb.updateEndGame();

      }

      // this.players.players.forEach((item: any) =>{
      //   if(player_id === item.player_id){
      //     if( !item.hasOwnProperty('own') ){
      //       alert('BEGIN END GAME!!! TWO!!!');
      //     }
      //   }
      // });
    }
  }

  updateEndGame(){
    setTimeout(()=>{
      this.rdb.updateEndGame(false);
    }, 2500);
  }
  
}
